import React from 'react';
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import {
  PreviewBars, PreviewGrid, PreviewHeader, PreviewKpis, PreviewLines, PreviewPage, PreviewPanel,
} from '../../../components/access-denied/preview/PreviewParts';

/** Prévia falsa das estatísticas para a tela de bloqueio (dados de exemplo fixos). */
const StatisticsLockedPreview = () => (
  <PreviewPage>
    <PreviewHeader icon={<BarChartOutlinedIcon />} title="Estatísticas" subtitle="Período de exemplo" />
    <PreviewKpis
      items={[
        { label: 'Atendimentos realizados', value: '000' },
        { label: 'Faturamento', value: 'R$ 0.000' },
        { label: 'Taxa de faltas', value: '0%' },
        { label: 'Novos clientes', value: '00' },
      ]}
    />
    <PreviewGrid>
      <PreviewPanel title="Atendimentos por mês">
        <PreviewBars values={[45, 62, 54, 78, 70, 88]} />
      </PreviewPanel>
      <PreviewPanel title="Resumo">
        <PreviewLines widths={[88, 70, 94, 62, 80]} />
      </PreviewPanel>
    </PreviewGrid>
  </PreviewPage>
);

export default StatisticsLockedPreview;
